import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const LocationFilledSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.9768 3.71356L5.47079 6.93042C2.44833 8.22577 0.937098 8.87344 1.00201 9.85631C1.06691 10.8392 2.65019 11.2825 5.81674 12.1691L10.5153 13.4847L11.8309 18.1833C12.7175 21.3498 13.1608 22.9331 14.1437 22.998C15.1266 23.0629 15.7742 21.5517 17.0696 18.5292L20.2864 11.0232C22.6087 5.60451 23.7699 2.89516 22.4374 1.56264C21.1048 0.230119 18.3955 1.39127 12.9768 3.71356Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const LocationFilledSize24 = hoc(forwardRef(LocationFilledSize24Component), 'LocationFilledSize24');

export { LocationFilledSize24 as default };
//# sourceMappingURL=LocationFilledSize24.js.map
